// Copyright ©️ 2026 eVolve MEP, LLC

import React from 'react';

import { MobileRestricted } from 'app/Layout/MobileRestricted';
import { useIsMobile } from 'hooks/useIsMobile';

export const MobileUnsupportedGate = ({ children }: { children: React.ReactNode }) =>
  useIsMobile() ? <MobileRestricted /> : children;
